import { HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ToastrModule } from "ngx-toastr";
import { IFrameModulesAppRoutingModule } from "./iframe-modules-app-routing.module";

import { biTranslateProviders } from "@globals/bi-translate/bi-translate-providers";
import { ConfirmationService } from "primeng/api";
import { IFrameModulesAppComponent } from "./iframe-modules-app.component";

@NgModule({
  declarations: [IFrameModulesAppComponent],
  imports: [BrowserModule, ToastrModule.forRoot(), BrowserAnimationsModule, IFrameModulesAppRoutingModule, HttpClientModule],
  providers: [...biTranslateProviders, ConfirmationService],
  bootstrap: [IFrameModulesAppComponent]
})
export class IFrameModulesAppModule {}
